import React, { useState } from 'react';
import { Grid, Typography, Box, Button, CircularProgress } from '@mui/material';
import ImageInput from 'src/App/Dashboards/Market/Components/Inputs/ImageInput';
import { User } from 'src/interfaces/iuser';
import { callApi } from 'src/core/callApi';
import { useDispatch } from 'react-redux';
import { getUserInfo } from 'src/store/Dashboard/actions';
import AutohideSnackbar from 'src/App/Dashboards/Market/Components/Alerts/AutohideSnackbar';

const OrganizationSettingsTab = ({ user }: { user: User }) => {
  const dispatch = useDispatch();
  const [organizationLogo, setOrganizationLogo] = useState<string[]>([]);
  const [currentOrganizationLogoURL, setCurrentOrganizationLogoURL] = useState<string | null>(
    user.organization_logo_url || null
  );
  const [isUpdatingLogo, setIsUpdatingLogo] = useState(false);
  const [status, setStatus] = useState<'success' | 'error' | null>(null);

  const handleSetNewLogo = async () => {
    setIsUpdatingLogo(true);
    const requestBody = {
      organization_logo_b64: organizationLogo[0],
    };
    const url = 'https://fld2j6mes8.execute-api.us-east-2.amazonaws.com/default/updateUserDetails';

    try {
      const response = await callApi(url, { body: requestBody }, true, false, '', 'POST', true);
      if (response.error) {
        setStatus('error');
      } else {
        dispatch(getUserInfo());
        setStatus('success');
        setCurrentOrganizationLogoURL(organizationLogo[0]);
      }
    } catch (error) {
      setStatus('error');
    } finally {
      setIsUpdatingLogo(false);
      setOrganizationLogo([]);
    }
  };

  return (
    <>
      <Grid container item direction="column" spacing={3}>
        <Grid item>
          <Typography variant="h6" component="h3">
            Organization Logo
          </Typography>
        </Grid>
        <Grid item>
          {currentOrganizationLogoURL ? (
            <Box
              component="img"
              src={currentOrganizationLogoURL}
              alt="Organization Logo"
              sx={{
                width: '150px',
                height: 'auto',
                objectFit: 'contain',
                border: '1px solid #ccc',
                borderRadius: 1,
                p: 1,
                mt: 0,
                pt: 0,
              }}
            />
          ) : (
            <Typography variant="body2" color="text.secondary">
              No logo uploaded yet.
            </Typography>
          )}
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Upload your organization's logo. This logo will be displayed in various parts of the
            application.
          </Typography>
        </Grid>
        <Grid item>
          <ImageInput
            cta="Upload Logo"
            images={organizationLogo}
            setImages={setOrganizationLogo}
            maxImageCount={1}
          />
        </Grid>

        {organizationLogo.length > 0 && (
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSetNewLogo}
              sx={{ mt: 1 }}
              disabled={isUpdatingLogo}
            >
              Set New Logo {isUpdatingLogo && <CircularProgress size={20} />}
            </Button>
          </Grid>
        )}
      </Grid>
      {status === 'success' && (
        <AutohideSnackbar message="Logo updated successfully" type="success" />
      )}
      {status === 'error' && <AutohideSnackbar message="Error updating logo" type="error" />}
    </>
  );
};

export default OrganizationSettingsTab;
